module.exports = __webpack_public_path__ + "55dcee93dfe47e572d2183fb4bc5d814.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/image/ic_home.svg
// module id = 1170
// module chunks = 0